import { useState, useEffect } from "react";
import { Stack, Pagination } from "@mui/material";
import Div from "../../../components/Div";
import PageTitle from "../../../components/PageTitle";
import { getOperationsStatusListHttp } from "../../../http/renewalHttp/RenewalHttp";
import { Badge } from 'react-bootstrap';
// --- ADDED MISSING IMPORTS ---
import { API_URL } from "../../../config";
import { getToken } from "../../../util/validation";

export default function GetOperationsStatus() {
    const [statusList, setStatusList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 15;
    
    // --- AUTH TOKEN FOR API CALLS ---
    const token = JSON.parse(getToken);

    const [agreementModal, setAgreementModal] = useState({ open: false, item: null });
    const [formData, setFormData] = useState({ client_name: '', price: '', term: '1 Year', company_name: '', domain_name: '', license_count: '0' });

    useEffect(() => {
        if (agreementModal.open && agreementModal.item) {
            setFormData({
                client_name: '',
                price: '',
                term: '1 Year',
                company_name: agreementModal.item.company_name || 'Client',
                domain_name: agreementModal.item.domain_name || 'example.com',
                license_count: agreementModal.item.number_of_seats ? String(agreementModal.item.number_of_seats) : '0'
            });
        }
    }, [agreementModal.open, agreementModal.item]);

    const handleGeneratePDF = async () => {
        const payload = {
            ...formData,
            renewal_id:agreementModal.item.renewal_id,
            company_name: agreementModal.item.domain_name,
        };

        try {
        const response = await fetch(API_URL + 'adminpanel/generate_agreement/', {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': token.login_token 
            },
            body: JSON.stringify(payload),
        });

        const result = await response.json();

        if (response.ok) {
            // SUCCESS: File is stored in GCS
            alert("Agreement stored successfully in Cloud Storage!");
            console.log("File Path:", result.file_url);
            setAgreementModal({ open: false, item: null }); // Close modal
            setFormData({ client_name: '', price: '', term: '1 Year', company_name: '', domain_name: '', license_count: '0' }); // Reset form data
        } else {
            alert("Error: " + result.error);
        }
    } catch (error) {
        alert("Network Error: Could not connect to server.");
    }
    };

    
const handleViewAgreement = async (gcsPath) => {
    if (!gcsPath) {
        alert("Agreement not found.");
        return;
    }

    try {
        const response = await fetch(API_URL + 'adminpanel/get_view_agreement_url/', {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': token.login_token 
            },
            body: JSON.stringify({ gcs_path: gcsPath }),
        });

        const result = await response.json();

        if (response.ok && result.url) {
            // Open the SECURE signed URL in a new tab
            window.open(result.url, '_blank');
        } else {
            alert("Error: Could not retrieve secure link.");
        }
    } catch (error) {
        alert("Network Error: Backend unreachable.");
    }
};

    useEffect(() => {
        const fetchStatusData = async () => {
            const response = await getOperationsStatusListHttp();
            if (response && response.status_list) {
                setStatusList(response.status_list);
            }
        };
        fetchStatusData();
    }, []);


    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = statusList.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(statusList.length / itemsPerPage);

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    return (
        <>
            <PageTitle title="Domain Status Dashboard" />

            {/* --- ADDED AGREEMENT MODAL UI --- */}
            {agreementModal.open && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ backgroundColor: 'white', padding: '25px', borderRadius: '8px', width: '450px', boxShadow: '0 4px 15px rgba(0,0,0,0.2)' }}>
                        <h5 className="mb-4">📜 Create Service Agreement</h5>
                        
                        <div className="mb-3">
                            <label className="fw-bold">Company Name:</label>
                            <input 
                                type="text" 
                                className="form-control" 
                                value={formData.company_name} 
                                onChange={(e) => setFormData({...formData, company_name: e.target.value})} 
                                placeholder="Enter company name"
                            />
                        </div>

                        <div className="mb-3">
                            <label className="fw-bold">Domain Name:</label>
                            <input 
                                type="text" 
                                className="form-control" 
                                value={formData.domain_name} 
                                onChange={(e) => setFormData({...formData, domain_name: e.target.value})} 
                                placeholder="Enter domain name"
                            />
                        </div>

                        <div className="mb-3">
                            <label className="fw-bold">License Count:</label>
                            <input 
                                type="number" 
                                className="form-control" 
                                value={formData.license_count} 
                                onChange={(e) => setFormData({...formData, license_count: e.target.value})} 
                                placeholder="Enter license count"
                            />
                        </div>
                        <div className="mb-3">
                            <label className="fw-bold">Client Contact Name:</label>
                            <input 
                                type="text" 
                                className="form-control" 
                                value={formData.client_name} 
                                onChange={(e) => setFormData({...formData, client_name: e.target.value})} 
                                placeholder="Enter name"
                            />
                        </div>

                        <div className="mb-3">
                            <label className="fw-bold">Agreed Price (₹):</label>
                            <input 
                                type="number" 
                                className="form-control" 
                                value={formData.price} 
                                onChange={(e) => setFormData({...formData, price: e.target.value})} 
                                placeholder="e.g. 50000"
                            />
                        </div>

                        <div className="mb-3">
                            <label className="fw-bold">Contract Term:</label>
                            <select 
                                className="form-control" 
                                value={formData.term} 
                                onChange={(e) => setFormData({...formData, term: e.target.value})}
                            >
                                <option value="1 Year">1 Year</option>
                                <option value="2 Years">2 Years</option>
                                <option value="3 Years">3 Years</option>
                                <option value="Monthly - Flex">Monthly - Flex</option>
                            </select>
                        </div>

                        <div className="mt-4 d-flex justify-content-end" style={{ gap: '10px' }}>
                            <button className="btn btn-secondary btn-sm" onClick={() => setAgreementModal({ open: false, item: null })}>Cancel</button>
                            <button 
                                className="btn btn-primary btn-sm" 
                                onClick={handleGeneratePDF}
                                disabled={!formData.client_name || !formData.price || !formData.company_name || !formData.domain_name || !formData.license_count}
                            >
                                Generate & Download PDF
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <Div className="col-md-12 margin_top">
                <table className="table table-bordered table-striped">
                    <thead style={{ backgroundColor: '#f8f9fa' }}>
                        <tr>
                            <th style={{ width: '50px' }}>Sr. No.</th>
                            <th>Domain Name</th>
                            <th>Status (From Comments)</th>
                            <th>Price</th>
                            <th>Add Agreement</th>
                            <th>View Agreement</th> 
                        </tr>
                    </thead>
                    <tbody>
                        {currentItems.length > 0 ? currentItems.map((item, index) => (
                            <tr key={item.renewal_id}>
                                <td>{indexOfFirstItem + index + 1}</td>
                                <td style={{ fontWeight: '500' }}>{item.domain_name}</td>
                                <td>
                                    <Badge bg="secondary" text="dark" className="fw-bold">
                                        {item.status_comment}
                                    </Badge>
                                </td>
                                <td style={{ fontWeight: 'bold' }}>
                                    {item.price ? `₹${item.price}` : 'N/A'}
                                </td>
                                <td>
                                    <button className="btn btn-primary btn-xs"
                                        onClick={() => setAgreementModal({ open: true, item: item })}>
                                        Create
                                    </button>
                                </td>

                                <td>
                                    <button
                                        className="btn btn-info btn-xs text-white"
                                        // This button is disabled if 'agreement_url' is null/empty in the DB
                                        disabled={!item.agreement_url}
                                        // Pass the path stored in the DB to the function
                                        onClick={() => handleViewAgreement(item.agreement_url)}
                                    >
                                        View
                                    </button>
                                </td>
                            </tr>
                        )) : (
                            <tr><td colSpan="5" className="text-center">Loading or no data...</td></tr>
                        )}
                    </tbody>
                </table>

                {statusList.length > itemsPerPage && (
                    <Div className="d-flex justify-content-end mt-3 mb-5">
                        <Stack spacing={2}>
                            <Pagination 
                                count={totalPages} 
                                page={currentPage} 
                                onChange={handlePageChange} 
                                color="primary"
                                shape="rounded"
                            />
                        </Stack>
                    </Div>
                )}
            </Div>
        </>
    );
}